export default "__VITE_ASSET__3580401c__"